export enum StaffFileSidebarViewEnum {
  GENERAL = 'Allgemein',
  WORKING_TIME = 'Arbeitszeit',
  CERTIFICATES = 'Zertifikate',
}
